import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { VmMachineService } from '../../../services/vm-machine.service';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { NotificationService } from 'src/app/shared/notification.service';
import { AuthService } from 'src/app/services/auth.service';
import { combineLatest } from 'rxjs';
import { SystemService } from '../../../services/system.service';

@Component({
  selector: 'app-channel-list',
  templateUrl: './channel-list.component.html',
  styleUrls: ['./channel-list.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush

})
export class ChannelListComponent implements OnInit {
  @Input() siteId: string;
  @Input() systemId: string;
  @Input() machineId: string;
  @Input() machineType: string;
  @Input() showDeleteButton: Boolean = false;
  channelArr$;
  products$;
  machineName;
  combObs$;
  showButtons: Boolean = false;
  selectedChannelId = null;
  constructor(
    private vmService: VmMachineService,
    private route: ActivatedRoute,
    public auth: AuthService,
    private notificationService: NotificationService,
    private sysService: SystemService,
    private router: Router) {
    //     this.route.params.subscribe((params:Params)=>{
    //     this.siteId = params['siteId']
    //     this.systemId = params['systemId']
    //     this.machineId = params['machineid']
    // })
    combineLatest(this.route.params).subscribe(([params]) => {
      this.siteId = params['siteId']
      this.systemId = params['systemId']
      this.machineId = params['machineid']

      this.vmService.getChannels(this.siteId, this.systemId, this.machineId);
    })

  }

  ngOnInit() {


    this.channelArr$ = this.vmService.channelChanged;

    this.channelArr$.subscribe((channelArr) => {
      console.log(channelArr)

    });

    // Get inventory

    //this.vmService.getChannels(this.siteId, this.systemId, this.machineId)

  }

  showDeleteButtons(value) {

    this.showButtons = value
  }

  onChannelClick(channelId: string, i, j) {
    this.selectedChannelId = channelId;
    this.vmService.setIndexofSelectedChannel(i, j)
    this.router.navigate(['channel', channelId], { relativeTo: this.route, queryParams: { type: this.machineType } })

  }

  getQuantity(inventoryData) {
    if (inventoryData)
      return inventoryData.quantity
  }

  isApplied(productId, inventoryData) {
    if(!inventoryData) return true;
    if (inventoryData && productId)
      return productId == inventoryData.productId
    return false
  }

  getActive(inventoryData) {
    if (inventoryData)
      return inventoryData.active
  }

  getStockStatus(inventoryData) {
    if (inventoryData) {
      return inventoryData.status == "SOLD_OUT" ? "SOLD OUT" : ""
    } else {
      return ""
    }
  }

  getName(name) {
    if (name)
      if (name.includes(" ")) {

        const words = name.split(/\s+/);

        // Initialize an array to store the first three letters of each word
        let result = "";

        // Loop through each word
        words.forEach(word => {
          // Get the first three letters of the word
          if (word.length > 7) {
            const firstThree = word.substring(0, 7);
            // Push the first three letters to the result array
            result = result + " " + firstThree;
          } else
            result = result + " " + word;

        });
        return result
        // return name;
      } else if (name.length > 10)
        return name.slice(0, 10)
      else
        return name

  }

  // productImage(id:number){
  //   console.log(id)
  //   let product$ = this.products$.pipe(
  //     map(newValue => newValue.filter(t=> t['id'] === id).map(obj => obj['imageUrl'])));

  //     product$.subscribe(console.log)
  //   return product$;


  //   //this.productService.getProductById(id)

  //   /**/
  // }

  async deleteChannel(event, channelId: string, i, j) {
    event.stopPropagation();
    let channel = await this.vmService.onChannelSelected(channelId);

    if (channel['productId']) {
      this.notificationService.showNotification('info', "Please deattach product before removing");
      return
    }


    this.vmService.deleteChannel(this.siteId, this.systemId, this.machineId, channelId).then(() => {
      this.notificationService.showNotification('success', "Document successfully deleted!");
    }).catch((error) => {
      this.notificationService.showNotification('error', `Error whie removing:${error}`);

    });


  }



}
